import axios from "axios";

const api_base = "https://minescape-api.chrisstar.com";
// const api_base = "localhost:8000";

const api_articles_get = `${api_base}/articles`;
const api_article_get  = `${api_base}/articles/`;

const articles = {
    get_thumbs: function() {
        return axios.get(`${api_articles_get}?thumbs=1`)
            .then(result => (result));
    },

    get_all: function() {
        return axios.get(api_articles_get)
            .then((result) => {
                return result;
            });
    },

    get_single: function(slug) {
        return axios.get(api_article_get + slug)
            .then((result) => {
                return result;
            });
    }
}

export {
    articles
}